import TemplateView from '../TemplateView';
import LoadingMoire from "../LoadingMoire";

export default class LoadingContainer extends TemplateView {
    constructor({
                    $containerEl,
                    contentComponent,
                    containerClass,
                    contentClass,
                    showAnimated = true,
                    hideAnimated = true,
                    loadingMoireConfig = {},
                    proxySetState = true
                }) {
        super($containerEl)

        this.state = {
            loading: false
        }

        this.contentComponent = contentComponent;
        this.containerClass = containerClass;
        this.contentClass = contentClass;
        this.showAnimated = showAnimated;
        this.hideAnimated = hideAnimated;

        this.params = {
            loadingMoireConfig,
            proxySetState
        }

        this.onStatePropertyChanged("loading", loading => this.loadingMoire.toggle(loading))
    }

    afterRender() {
        this.content = this.find(".content");
        if (this.contentComponent instanceof Array) {
            this.contentComponent.forEach(c => c.init(this.content))
            this.registerChildComponents(...this.contentComponent)
        }
        else {
            this.contentComponent.init(this.content);
            this.registerChildComponents(this.contentComponent)
        }

        this.loadingMoire = new LoadingMoire(this.params.loadingMoireConfig).init(this.$el)
        this.loadingMoire.showAnimated = this.showAnimated;
        this.loadingMoire.hideAnimated = this.hideAnimated;
    }

    templateHtml() {
        return "<div class='loadingContainer <%=containerClass%>'>" +
               "  <div class='content <%=contentClass%>'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            containerClass: this.containerClass,
            contentClass: this.contentClass,
        }
    }

    setState(stateChanges) {
        super.setState(stateChanges)
        if (this.params.proxySetState) this.applyForChildrenComponents(child => child.setState(stateChanges))
    }

    hide() {
        super.hide()
        this.loadingMoire.toggle(false)
    }

    show() {
        super.show()
        this.loadingMoire.toggle(this.state.loading)
    }
}


// WEBPACK FOOTER //
// ./web/js/util/LoadingContainer.js